import React, { useState, useEffect } from "react";
import "./chatbotBubble.css";

const ChatbotBubble = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  // Load history from sessionStorage on mount
  useEffect(() => {
    const storedMessages = sessionStorage.getItem("chatbotMessages");
    if (storedMessages) {
      setMessages(JSON.parse(storedMessages));
    }
  }, []);

  // Persist messages to sessionStorage on change
  useEffect(() => {
    sessionStorage.setItem("chatbotMessages", JSON.stringify(messages));
  }, [messages]);

  const toggleChat = () => setIsOpen(!isOpen);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { role: "user", content: input };
    setMessages((prev) => [...prev, userMessage]);
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/chatbot`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: input }),
      });

      const data = await response.json();

      const botReply = {
        role: "bot",
        content: data.reply,
        links: data.links || [],
      };
      setMessages((prev) => [...prev, botReply]);
    } catch (err) {
      console.error("Chatbot error:", err);
      setMessages((prev) => [
        ...prev,
        { role: "bot", content: "Error responding.", links: [] },
      ]);
    } finally {
      setInput("");
      setLoading(false);
    }
  };

  return (
    <div className="chatbot-bubble">
      <button onClick={toggleChat} className="chatbot-toggle-btn">
        {isOpen ? "✖" : "💬"}
      </button>

      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-messages">
            {messages.map((msg, idx) => (
              <div key={idx} className={`chatbot-message ${msg.role}`}>
                <div>{msg.content}</div>
                {msg.links && msg.links.length > 0 && (
                  <ul className="chatbot-links">
                    {msg.links.map((link, i) => (
                      <li key={i}>
                        <a href={link.path}>{link.title}</a>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
            {loading && <div className="chatbot-message bot">Typing...</div>}
          </div>

          <div className="chatbot-input-area">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Ask me anything..."
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />
            <button onClick={sendMessage} disabled={loading}>
              Send
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatbotBubble;
